import FaqPDF from "@/content/ph/pdf/FAQ_ELGAP_EN.pdf";

export default {
  "title": "Travel360",
  "infos": [
    "Comprehensive protection against <b>COVID-19</b> for your overseas travels",
    "Cashless <b>medical care</b>",
    "Protection against <b>losses of your electronic gadgets and jewellery</b>, as well as coverage for <b>any unexpected travel delays</b>",
    "Coverage extends to your <b>sports and golf equipment</b>",
    "Purchase and secure your travel up to <b>3 hours before your departure</b>"
  ],
  "moreDetail": "<a>Click here</a> for more details.",
  "link": FaqPDF,
}
